import React, { Suspense, useMemo, memo } from 'react';
import { flowType } from '@utility/userInfo';
import Loader from '@components/common/Loader/newLoaderModal';
import ServerAppOrder from './ServerAppMenuOrderV2';

const MenuOrderV2 = props => {
  const flow = useMemo(() => flowType(), []);
  const ComponentToRender = useMemo(() => {
    switch (flow) {
      case 'serverApp':
        return ServerAppOrder;
      default:
        return null;
    }
  }, [flow]);

  return (
    <Suspense fallback={<Loader />}>
      {ComponentToRender ? <ComponentToRender {...props} /> : null}
    </Suspense>
  );
};

export default memo(MenuOrderV2);
